import styled, { css } from 'styled-components';

import { delayedFadeInRight, delayedFadeInLeft, fadeInRight, fadeInLeft } from 'styles/animations';
import { media } from 'styles/utils';

export const TitleContainer = styled.div<TitleContainerProps>`
  width: 80%;
  display: flex;
  flex-direction: column;
  gap: 8px;

  ${media.desktop<TitleContainerProps>`
    min-height: 0;
    width: 105%;
  `}
`;

type TitleContainerProps = {
  large?: boolean;
};

export const Title = styled.span<TitleProps>`
  font-family: ${({ theme }) => theme.fonts.baloo};
  font-weight: 800;
  font-size: ${({ small }) => small ? '28px' : '32px'};
  background-color: ${({ theme }) => theme.colors.blue};
  color: ${({ theme }) => theme.colors.white};
  border-radius: 3px;
  line-height: 44px;
  padding: 0px 12px;
  align-self: center;
  white-space: nowrap;
  animation: ${fadeInLeft} 500ms ease-out;

  &:nth-child(odd) {
    ${media.desktop`
      align-self: flex-end;
    `}
  }

  &:nth-child(even) {
    animation: ${fadeInRight} 500ms ease-out;

    ${media.desktop`
      align-self: flex-start;
    `}
  }

  ${({ delayed }) => delayed && css`
    animation: ${delayedFadeInLeft} 2s ease-out;

    &:nth-child(even) {
      animation: ${delayedFadeInRight} 2s ease-out;
    }
  `}

  ${({ variant, theme }) => variant === 'dark' && css`
    background-color: ${theme.colors.blue.dark};
    color: ${theme.colors.white};
  `}

  ${({ variant, theme }) => variant === 'light' && css`
    background-color: ${theme.colors.white};
    color: ${theme.colors.blue};
  `}

  ${({ variant, theme }) => variant === 'lightReversed' && css`
    background-color: ${theme.colors.blue};
    color: ${theme.colors.white};
  `}
`;

type TitleProps = {
  variant?: 'dark' | 'light' | 'lightReversed';
  delayed?: boolean;
  small?: boolean;
}
